export class VQTPESQDATA {

  ID: number;
  VQT_TimeStamp: Date;
  VQuad_Timestamp: Date;

  DCOSS_TimeStamp: Date;
  DCOSS_TrunkTS: string;
  DCOSS_CallID: string;
  DCOSS_DID: string;
  DCOSS_ANI: string;
  Call_Timestamp: Date;
  VQuad_Location: string;
  VQuad_PhoneID: string;

  VQuad_Lat_Long: string;//VQuad_Lat_Long: string; /// uncommented coz  VQuad_Lat_Long exists in vqtdata table
  //GPS_Position: string; /// commented coz  GPS_Position doesnt exist in vqtdata table
  GPS_Lat: number;
  GPS_Long: number;

  Deg_File_Name: string;
  Rating: string;
  PESQ_Score: number;
  DAQ: number;
  PESQ_LQ: number;
  PESQ_MOS: number;
  PESQ_WB: number;
  PSQMPLUS: number;
  PESQ_Average_offset: number;
  PESQ_Max_Offset: number;
  PESQ_Min_Offset: number;
  Number_All_clipping: number;
  Duration_ALL_Clipping: number;
  Mean_Duration_ALL_Clipping: number;
  duration_hangover: number;
  Number_of_hangover: number;
  Average_Jitter: number;
  RSSI: number;

  CallType_Orig: string;
  CallType_Term: string;
  VQuad_CallID: string;

  VQTTimestamp: Date;


  PAMS_LQ: number;
  PAMS_LE: number;
  PSQM: number;


  Degraded: string;

  Reference: string;
  Inventory: string;
  User_ID: string;

  PAMS_Avg_Offset: number;
  PAMS_Offset_Confidence: number;
  Reference_Active_Level: number;
  Reference_Activity: number;
  Reference_Noise: number;
  Reference_Peak: number;
  Degraded_Active_Level: number;
  Degraded_Activity: number;
  Degraded_Noise: number;
  Degraded_Peak: number;
  PAMS_Max_Offset: number;
  PAMS_Min_Offset: number;
  PAMS_Std_Deviation_Offsets: number;
  PAMS_utterances: number;
  PAMS_Proportion_degraded_muted: number;
  PAMS_Max_mute: number;
  PAMS_Median_Offset: number;
  PSQM_Slt_Interval_WeightFactor: number;

  PESQ_Offset_Confidence: number;

  PESQ_Std_Deviation_Offset: number;
  PESQ_utterances: number;
  PESQ_Proportion_degraded_muted: number;
  PESQ_Max_Mute: number;
  PESQ_Median_Offset: number;
  PESQ_Min_Offset_: number;
  PESQ_Max_Offset_: number;
  PESQ_Std_Deviation_Offset_: number;
  Num_samples_reference: number;
  Speech_activity_reference: number;
  Number_of_samples_degraded: number;
  Speech_activity_degraded: number;
  Model_selected: number;
  Sample_rate: number;
  Symmetric_disturbance: number;
  Asymmetric_disturbance: number;
  Proportion_muted: number;
  longest_muted: number;
  Mean_DC_reference: number;
  ASL_reference: number;
  Mean_noise_reference: number;
  RMS_reference: number;
  Mean_DC_degraded: number;
  ASL_degraded: number;
  Mean_noise_degraded: number;
  RMS_degraded: number;
  Speech_Level_Gain: number;
  Noise_Level_Gain: number;
  Ie: number;
  Mean_delay: number;
  PESQ_Version_number: number;
  Minimum_delay: number;
  Maximum_delay: number;
  Standard_deviation_of_delay: number;
  PESQ_Average_offset_: number;
  PESQ_Offset_Confidence_: number;
  PESQ_Median_Offset_: number;
  Duration_of_speech: number;
  Proportion_All_clipping: number; 0

  Proportion_Without_Front: number;
  Number_Without_Front: number;
  Duration_Without_Front: number;
  Mean_Duration_Without_Front: number;
  Proportion_Front: number;
  Number_Front_clipping: number;
  Duration_Front_Clipping: number;
  Mean_Duration_Front_Clipping: number;
  Proportion_Back: number;
  Number_Back_clipping: number;
  Duration_Back_Clipping: number;
  Mean_Duration_Back_Clipping: number;

  PESQ_Per_Utterance: string;
  PESQLQ_Per_Utterance: string;
  PESQLQO_Per_Utterance: string;
  PESQ_WB_Utterance: string;
  PESQDelay_Per_Utterance: string;
  PAMSDelay_Per_Utterance: string;
  Rating_Reason: string;
  AVGofRTD: number;

  NA6: string;
  NA7: string;
  NA8: string;
  NA9: string;

  constructor() {
    this.ID = 0;
    this.VQT_TimeStamp = new Date();
    this.VQuad_Timestamp = new Date();

    //this.DCOSS_TimeStamp=new Date();
    //this.DCOSS_TrunkTS = "";
    //this.DCOSS_CallID = "";
    //this.DCOSS_DID = "";
    //this.DCOSS_ANI = "";
    this.Call_Timestamp = new Date();
    this.VQuad_Location = "";
    this.VQuad_PhoneID = "";

    this.VQuad_Lat_Long = "";//VQuad_Lat_Long= "";; /// uncommented coz  VQuad_Lat_Long exists in vqtdata table
    //this.GPS_Position = ""; /// commented coz  GPS_Position doesnt exist in vqtdata table
    this.GPS_Lat = 0;
    this.GPS_Long = 0;

    this.Deg_File_Name = "";
    this.Rating = "";
    this.PESQ_Score = 0;
    this.DAQ = 0;
    this.PESQ_LQ = 0;
    this.PESQ_MOS = 0;
    this.PESQ_WB = 0;
    this.PSQMPLUS = 0;
    this.PESQ_Average_offset = 0;
    this.PESQ_Max_Offset = 0;
    this.PESQ_Min_Offset = 0;
    this.Number_All_clipping = 0;
    this.Duration_ALL_Clipping = 0;
    this.Mean_Duration_ALL_Clipping = 0;
    this.duration_hangover = 0;
    this.Number_of_hangover = 0;
    this.Average_Jitter = 0;
    this.RSSI = 0;

    this.CallType_Orig = "";
    this.CallType_Term = "";
    this.VQuad_CallID = "";

    //this.VQTTimestamp = new Date();

    //Start of main events screen hidden
    this.PAMS_LQ = 0;
    this.PAMS_LE = 0;
    this.PSQM = 0;

    this.Degraded = "";

    this.Reference = "";
    this.Inventory = "";
    this.User_ID = "";

    this.PAMS_Avg_Offset = 0;
    this.PAMS_Offset_Confidence = 0;
    this.Reference_Active_Level = 0;
    this.Reference_Activity = 0;
    this.Reference_Noise = 0;
    this.Reference_Peak = 0;
    this.Degraded_Active_Level = 0;
    this.Degraded_Activity = 0;
    this.Degraded_Noise = 0;
    this.Degraded_Peak = 0;
    this.PAMS_Max_Offset = 0;
    this.PAMS_Min_Offset = 0;
    this.PAMS_Std_Deviation_Offsets = 0;
    this.PAMS_utterances = 0;
    this.PAMS_Proportion_degraded_muted = 0;
    this.PAMS_Max_mute = 0;
    this.PAMS_Median_Offset = 0;
    this.PSQM_Slt_Interval_WeightFactor = 0;

    this.PESQ_Offset_Confidence = 0;

    this.PESQ_Std_Deviation_Offset = 0;
    this.PESQ_utterances = 0;
    this.PESQ_Proportion_degraded_muted = 0;
    this.PESQ_Max_Mute = 0;
    this.PESQ_Median_Offset = 0;
    this.PESQ_Min_Offset_ = 0;
    this.PESQ_Max_Offset_ = 0;
    this.PESQ_Std_Deviation_Offset_ = 0;
    this.Num_samples_reference = 0;
    this.Speech_activity_reference = 0;
    this.Number_of_samples_degraded = 0;
    this.Speech_activity_degraded = 0;
    this.Model_selected = 0;
    this.Sample_rate = 0;
    this.Symmetric_disturbance = 0;
    this.Asymmetric_disturbance = 0;
    this.Proportion_muted = 0;
    this.longest_muted = 0;
    this.Mean_DC_reference = 0;
    this.ASL_reference = 0;
    this.Mean_noise_reference = 0;
    this.RMS_reference = 0;
    this.Mean_DC_degraded = 0;
    this.ASL_degraded = 0;
    this.Mean_noise_degraded = 0;
    this.RMS_degraded = 0;
    this.Speech_Level_Gain = 0;
    this.Noise_Level_Gain = 0;
    this.Ie = 0;
    this.Mean_delay = 0;
    this.PESQ_Version_number = 0;
    this.Minimum_delay = 0;
    this.Maximum_delay = 0;
    this.Standard_deviation_of_delay = 0;
    this.PESQ_Average_offset_ = 0;
    this.PESQ_Offset_Confidence_ = 0;
    this.PESQ_Median_Offset_ = 0;
    this.Duration_of_speech = 0;
    this.Proportion_All_clipping = 0;

    this.Proportion_Without_Front = 0;
    this.Number_Without_Front = 0;
    this.Duration_Without_Front = 0;
    this.Mean_Duration_Without_Front = 0;
    this.Proportion_Front = 0;
    this.Number_Front_clipping = 0;
    this.Duration_Front_Clipping = 0;
    this.Mean_Duration_Front_Clipping = 0;
    this.Proportion_Back = 0;
    this.Number_Back_clipping = 0;
    this.Duration_Back_Clipping = 0;
    this.Mean_Duration_Back_Clipping = 0;

    this.PESQ_Per_Utterance = "";
    this.PESQLQ_Per_Utterance = "";
    this.PESQLQO_Per_Utterance = "";
    this.PESQ_WB_Utterance = "";
    this.PESQDelay_Per_Utterance = "";
    this.PAMSDelay_Per_Utterance = "";
    this.Rating_Reason = "";
    this.AVGofRTD = 0;
    //End of main events screen hidden

    //this.NA6 = "";
    //this.NA7 = "";
    //this.NA8 = "";
    //this.NA9 = "";

  }

}
